
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Onethreeforceurbaniaonrentinpune() {



  const cardData =
  {
    keyword: ' 13 Seater Force Urbania on Rent in Pune',
    heading: 'Vaishnavi Travels: 13 Seater Force Urbania on Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides premium and reliable 13 Seater Force Urbania on Rent in Pune, perfect for family trips, weddings, corporate travel, and outstation tours. This luxury vehicle is equipped with spacious push-back seats, strong air-conditioning, modern interiors, and ample luggage space, ensuring a smooth and comfortable journey for small to medium-sized groups. With professional chauffeurs, timely pickups, and flexible booking options, we make travel convenient and hassle-free. Whether it’s a local city ride, weekend getaway, or religious yatra, Vaishnavi Travels guarantees safe, stylish, and comfortable 13 seater Force Urbania rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],

"services": [
  {
    "name": "13 Seater Urbania Van Pune",
    "description": "Hire a premium 13 seater Urbania van in Pune for all types of group travel. Ideal for families, corporate teams, or tour groups, this vehicle offers spacious interiors, individual pushback seating, ample legroom, and a smooth ride for both short city rides and long-distance trips. The van is designed to accommodate up to 13 passengers comfortably while maintaining luggage space and air-conditioned convenience. Whether you're heading to a religious destination, tourist attraction, or business event, our 13 seater Urbania is the perfect balance of comfort and functionality."
  },
  {
    "name": "Force Urbania 13 Seater Hire",
    "description": "Book Force Urbania 13 Seater in Pune for a reliable and modern transportation option. This van is part of Force Motors' new-age luxury range, equipped with enhanced suspension, sleek aesthetics, and top-tier safety features. It is a top choice for travel agents, event planners, and group tour operators who want to ensure premium travel for their clients. Great for one-day trips, multi-day tours, and airport transfers. Comes with professional chauffeur, clean interiors, and sanitization before every journey."
  },
  {
    "name": "AC Urbania 13 Seater Rental Pune",
    "description": "Travel in cool comfort with our AC Urbania 13 Seater rental in Pune. These air-conditioned vans offer an escape from the harsh weather during summer or long journeys. Interiors are designed to keep passengers relaxed, with efficient cooling vents, tinted windows, and minimal noise. Perfect for corporate guests, VIP travel, and family tours. Enjoy uninterrupted rides with charging ports, reading lights, and music system. Full-day and half-day rentals available at flexible pricing."
  },
  {
    "name": "Wedding 13 Seater Urbania Hire Pune",
    "description": "Ensure elegant and coordinated transport for your wedding events in Pune with our 13 seater Urbania hire service. This van is ideal for ferrying close family members, the bride/groom party, or senior guests between venues, hotels, and functions. Comes with options for vehicle decoration, uniformed driver, and custom pickup schedules. The ride offers a VIP feel with plush seats and ample space for traditional attire. Available for hourly, full-day, or multi-day wedding use."
  },
  {
    "name": "Corporate Urbania 13 Seater",
    "description": "For business events, airport transfers, and daily office commutes, our corporate 13 seater Urbania in Pune provides a stylish and professional solution. Designed to cater to executives and company guests, it features uniform interiors, quiet cabin, Wi-Fi-enabled options, and trained drivers. Ideal for conference shuttles, off-site meetings, or site visits. Contracts available for short-term or monthly rental with detailed billing and support. Prioritizes punctuality, comfort, and brand image."
  },
  {
    "name": "Family Tour 13 Seater Urbania Pune",
    "description": "Make your family outings special with our 13 seater Urbania for family tours from Pune. Whether it’s a weekend retreat, temple tour, or city hopping plan, this van allows your entire family to travel together in comfort. Onboard features include bottle holders, adjustable AC, music player, and overhead storage. Drivers are courteous and well-versed with local and outstation routes. Available for round-trip bookings, long vacations, and holiday special offers."
  },
  {
    "name": "13 Seater Urbania for Outstation",
    "description": "Travel out of Pune in luxury with our 13 seater Urbania van tailored for outstation trips. This vehicle offers better fuel efficiency, smooth handling, and comfort for journeys lasting several hours or days. Perfect for visiting nearby cities like Mumbai, Shirdi, Mahabaleshwar, Goa, or Nashik. Packages include fuel, tolls, and driver allowance. Recommended for groups preferring privacy over crowded tourist buses without sacrificing convenience."
  },
  {
    "name": "13 Seater Van with Driver Pune",
    "description": "Rent a 13 seater Urbania van in Pune with an experienced and uniformed driver. All our drivers are background verified, trained in customer service, and familiar with major city and outstation routes. The van comes clean, fueled, and inspected before each trip. Ideal for corporate travel, school trips, or senior citizen groups who need reliable and safe transport. On-time service, full trip support, and customer assistance are part of the package."
  },
  {
    "name": "Weekend Trip 13 Seater Urbania",
    "description": "Plan the perfect weekend escape from Pune with our 13 seater Urbania vans. Visit Lonavala, Lavasa, Bhimashankar, Malshej Ghat, or Alibaug with friends or family in a vehicle built for road travel. Enjoy smooth driving experience, reclining seats, ample boot space, and onboard entertainment. Ideal for 1-2 day excursions with flexible pick-up and drop timing. Affordable weekend packages available for leisure, adventure, and religious tours."
  },
  {
    "name": "Pune City Ride 13 Seater Urbania",
    "description": "Get around Pune with comfort and convenience by booking our 13 seater Urbania for city rides. Whether you need it for shopping, events, local darshan, or guest movement during functions, this van ensures punctuality, comfort, and professionalism. Comes with AC, trained driver, and local route expertise. Hourly rentals, day plans, and last-minute bookings available at competitive prices. Ideal for tourists, corporate guests, and families alike."
  },
  {
    "name": "Online 13 Seater Booking Pune",
    "description": "Book your 13 seater Urbania in Pune online in just a few clicks. Our booking platform allows you to check availability, select travel duration, choose pickup/drop locations, and confirm instantly. Get transparent pricing, online payment options, and trip updates via SMS or email. Perfect for both planned trips and urgent bookings. You can also add custom requirements like multiple pickups, vehicle decoration, or multilingual drivers during the online process."
  },
  {
    "name": "Group Travel Urbania 13 Seater",
    "description": "Whether it’s a tour, celebration, or pilgrimage, our group travel Urbania vans offer unmatched comfort for 13 passengers. Travel together in style with pushback seats, clean interiors, and smooth suspension. Bookings are available for full-day rentals, multi-city travel, and fixed-route transfers. Great for friends, colleagues, or club groups heading for events, concerts, hill stations, or religious tours. Addons include mineral water, route planning, and stopover customization."
  },
  {
    "name": "Urbania for School Tour 13 Seater",
    "description": "Book 13 seater Urbania vans in Pune for safe and reliable school tours and educational trips. Our vans are maintained with a focus on safety—child locks, seatbelts, and first aid kits included. Drivers are background-verified and well-versed with school protocols. Ideal for field visits, science fairs, competitions, or teacher-led excursions. Provides a secure and manageable alternative to large buses for smaller student groups."
  }
],
"tableData": [
  ["13 Seater Urbania Van Pune", "Force Urbania 13 Seater Hire"],
  ["AC Urbania 13 Seater Rental Pune", "Wedding 13 Seater Urbania Hire Pune"],
  ["Corporate Urbania 13 Seater", "Family Tour 13 Seater Urbania Pune"],
  ["13 Seater Urbania for Outstation", "13 Seater Van with Driver Pune"],
  ["Weekend Trip 13 Seater Urbania", "Pune City Ride 13 Seater Urbania"],
  ["Online 13 Seater Booking Pune", "Group Travel Urbania 13 Seater"],
  ["Urbania for School Tour 13 Seater"]
],




"whychoose": [
  {
    "WhyChooseheading": "13 Seater Force Urbania on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers the premium 13-seater Force Urbania on rent in Pune, ideal for luxury group travel, corporate use, and family outings."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "The 13-seater Urbania features reclining seats, ample legroom, and superior suspension for a relaxed and comfortable journey."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each Urbania van is deep-cleaned, sanitized, and regularly serviced to ensure safety, hygiene, and top performance."
  },
  {
    "WhyChooseheading": "Perfect for Short & Long-Distance Travel",
    "WhyChoosedescription": "Whether it's a city tour, outstation trip, corporate transfer, or wedding event, our 13-seater Urbania fits all travel needs."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs for a Smooth Ride",
    "WhyChoosedescription": "Our well-trained, courteous drivers are experienced in both local and outstation routes, ensuring timely and safe travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "We offer hourly, full-day, and multi-day rental packages, customizable to match your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "All rentals include fuel, tolls, driver allowance, and taxes — so you enjoy a smooth booking experience without surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our team is available round-the-clock to assist with bookings, schedule changes, and real-time travel support."
  }
]

















  }






const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles on rent in Pune, ideal for small group travel, corporate transfers, and family outings.',
    },
    {
      question: 'What are the key features of the 13 seater Force Urbania?',
      answer: 'The 13 seater Force Urbania offers spacious seating, comfortable legroom, air-conditioning, and modern interiors designed for a premium travel experience.',
    },
    {
      question: 'Are these vehicles well-maintained and driven by professionals?',
      answer: 'Absolutely! All our Force Urbania vehicles are regularly serviced and maintained. Rentals include experienced and courteous drivers who ensure a safe and pleasant journey.',
    },
    {
      question: 'What is the approximate rental cost for a 13 seater Force Urbania in Pune?',
      answer: 'Rental prices typically start at around ₹3,200 for local half-day usage. Pricing varies based on trip duration, distance, and specific requirements.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for outstation trips?',
      answer: 'Yes, we offer outstation packages with transparent pricing for day trips and multi-day journeys outside Pune.',
    },
    {
      question: 'How far in advance should I book the 13 seater Force Urbania?',
      answer: 'It is recommended to book at least 2-3 days in advance, especially during weekends and peak travel seasons to ensure vehicle availability.',
    },
    {
      question: 'Is it possible to customize pickup and drop locations?',
      answer: 'Yes, we offer flexible pickup and drop-off points within Pune and surrounding areas to suit your convenience.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Suresh Patil",
    position: "Corporate Executive",
    feedback:
      "We hired the 13 seater Force Urbania from Vaishnavi Travels for our office transfer. The vehicle was clean, comfortable, and the driver was punctual and professional. Highly recommended!",
    rating: 5,
  },
  {
    name: "Ms. Ritu Sharma",
    position: "Family Trip Organizer",
    feedback:
      "The 13 seater Force Urbania was perfect for our family outing. Spacious, AC worked well, and the driver was very courteous and helpful. Excellent service by Vaishnavi Travels.",
    rating: 5,
    style: "style-2",
  }
];






























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Force Urbania on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/13-seater-urbania-rental-pune.jpg",
  "description": "Hire 13 Seater Force Urbania in Pune with Vaishnavi Travels. Perfect for weddings, corporate travel, school tours, family outings, and outstation trips. AC Urbania van with driver available.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "540"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3600",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/13-seater-force-urbania-on-rent-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>13 Seater Force Urbania on Rent in Pune | AC Van with Driver | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Hire 13 Seater Force Urbania in Pune with Vaishnavi Travels. Perfect for weddings, corporate travel, school tours, family outings, and outstation trips. AC Urbania van with driver available."
  />
  <meta
    name="keywords"
    content="13 Seater Urbania Van Pune, Force Urbania 13 Seater Hire, AC Urbania 13 Seater Rental Pune, Wedding 13 Seater Urbania Hire Pune, Corporate Urbania 13 Seater, Family Tour 13 Seater Urbania Pune, 13 Seater Urbania for Outstation, 13 Seater Van with Driver Pune, Weekend Trip 13 Seater Urbania, Pune City Ride 13 Seater Urbania, Online 13 Seater Booking Pune, Group Travel Urbania 13 Seater, Urbania for School Tour 13 Seater"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onethreeforceurbaniaonrentinpune;